;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();const DEFAULT_TIMEOUT_MS = 3000;
const DEFAULT_INTERVAL_MS = 100;
const DEFAULT_VISIBLE_TIMEOUT_MS = 3000;

function isHiddenByClosedState(element: HTMLElement): boolean {
	if (element.getAttribute("data-state") !== "closed") {
		return false;
	}

	// Collapsible roots stay "closed" while their trigger remains visible.
	if (element.matches("[data-slot='collapsible']")) {
		return false;
	}

	// Radix/Vaul triggers stay visible while their popup is closed.
	if (
		element.matches(
			"[data-slot='collapsible-trigger'], [data-slot='dropdown-menu-trigger'], [data-slot='dialog-trigger'], [data-slot='sheet-trigger'], [data-slot='drawer-trigger'], [data-slot='popover-trigger'], [data-slot='tooltip-trigger']",
		) ||
		element.getAttribute("aria-haspopup") === "menu" ||
		element.getAttribute("aria-haspopup") === "dialog"
	) {
		return false;
	}

	return true;
}

export function isTourTargetVisible({ target }: { target: string }): boolean {
	const element = document.querySelector(target);
	if (!(element instanceof HTMLElement)) {
		return false;
	}

	if (!element.isConnected || element.getAttribute("hidden") !== null) {
		return false;
	}

	let current: HTMLElement | null = element;
	while (current) {
		if (isHiddenByClosedState(current)) {
			return false;
		}
		current = current.parentElement;
	}

	const style = window.getComputedStyle(element);
	if (style.display === "none" || style.visibility === "hidden") {
		return false;
	}

	const rect = element.getBoundingClientRect();
	// Opacity may be 0 for group-hover affordances; layout size still makes a valid target.
	return rect.width > 0 && rect.height > 0;
}

export async function waitForTourTarget({
	target,
	timeoutMs = DEFAULT_TIMEOUT_MS,
	intervalMs = DEFAULT_INTERVAL_MS,
	signal,
}: {
	target: string;
	timeoutMs?: number;
	intervalMs?: number;
	signal?: AbortSignal;
}): Promise<boolean> {
	const deadline = Date.now() + timeoutMs;

	while (Date.now() < deadline) {
		if (signal?.aborted) {
			return false;
		}

		if (isTourTargetVisible({ target })) {
			return true;
		}

		await new Promise<void>((resolve) => {
			window.setTimeout(resolve, intervalMs);
		});
	}

	if (signal?.aborted) {
		return false;
	}

	return isTourTargetVisible({ target });
}

export const TOUR_TARGET_VISIBLE_WAIT_MS = DEFAULT_VISIBLE_TIMEOUT_MS;
